import type { UseQueryOptions, UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { PatientTreatmentSchedule } from "../schemas/Treatment";

const queryKeyPrefix = "getPatientTreatmentSchedule";
type QueryKey = readonly [typeof queryKeyPrefix, number];
const getPatientTreatmentScheduleQueryKey = (patientID: number): QueryKey => [queryKeyPrefix, patientID];

export const useGetPatientTreatmentSchedule = (
  patientID: number,
  options?: UseQueryOptions<PatientTreatmentSchedule, Error, PatientTreatmentSchedule, QueryKey>
): UseQueryResult<PatientTreatmentSchedule, Error> => {
  const client = useApiClient();

  return useQuery(
    getPatientTreatmentScheduleQueryKey(patientID),
    () => client.getPatientTreatmentSchedule(patientID),
    options
  );
};
